<template>
    <section>
        <CustomLoading v-if="this.endingTask == true" :msg="loadingMsg" />
        <section v-else class="abstract-container">
            <section class="infos-container">
                <section class="info-header">
                    <h1>{{ this.$t('generalConfigs') }}</h1>
                    <b-icon-pencil-square @click="() => goToTab(0)"></b-icon-pencil-square>
                </section>
                <section class="info-content">
                    <span>Informações Gerais</span>
                    <p><strong>Nome do Indicador:</strong> {{ this.generalInfos.indicatorInfo.indicatorName }}</p>
                    <p><strong>Tipo de Cálculo:</strong> {{ this.generalInfos.indicatorInfo.calcType }}</p>
                    <p><strong>Unidade de Medida:</strong> {{ this.generalInfos.indicatorInfo.unit }}</p>
                    <span>Posicionamentos</span>
                    <p><strong>Locais Posicionados:</strong> {{ this.generalInfos.positionsOnTree.length }}</p>
                    <section v-for="(ind, idx) in this.generalInfos.positionsOnTree" :key="`pos-${idx}`">

                        <p><strong>Posicionado em Tela:</strong> {{ ind.onMonitoringScreen == true ? 'Sim' : 'Não' }}
                        </p>
                        <p v-if="ind.onMonitoringScreen"><strong>Tela:</strong> {{ ind.screenName }}</p>
                        <p v-if="ind.onMonitoringScreen"><strong>Área:</strong> {{ ind.areaName }}</p>
                        <p v-if="ind.isDeleted == true"><strong>Ação:</strong> Deletando</p>
                    </section>
                </section>
            </section>
            <section class="infos-container" v-if="showRefs == true">
                <section class="info-header">
                    <h1>{{ this.$t('collectedReference') }}</h1>
                    <b-icon-pencil-square @click="() => goToTab(1)"></b-icon-pencil-square>
                </section>

                <section class="info-content">
                    <span>Equação Criada</span>
                    <p><strong>Expressão: </strong>{{ this.equationReal }}</p>
                    <span>Coletores Criados</span>
                    <p v-if="this.refsToShow.length == 0">Nenhum coletor será criado.</p>

                    <section v-for="(col, colIdx) in this.refsToShow" :key="`col-${colIdx}`">
                        <section v-if="col.type == 'collector' && col.colType == 'opc'">
                            <p><strong>Base de Coleta:</strong> {{ col.collectorBase }}</p>
                            <p><strong>Nome da Tag:</strong> {{ col.tagname }}</p>
                            <p><strong>Tag OPC:</strong> {{ col.opctagname }}</p>
                            <p><strong>IP do Servidor:</strong> {{ col.host }}</p>
                            <p><strong>Nome do Servidor:</strong> {{ col.opcserver }}</p>
                            <p><strong>Saturação Mínima:</strong> {{ col.minSaturation }}</p>
                            <p><strong>Saturação Máxima:</strong> {{ col.maxSaturation }}</p>
                        </section>
                        <section v-if="col.type == 'collector' && col.colType == 'pisystem'">
                            <p><strong>Base de Coleta:</strong> {{ col.collectorBase }}</p>
                            <p><strong>Nome da Tag:</strong> {{ col.tagname }}</p>
                            <p><strong>Tag Pisystem:</strong> {{ col.pitagname }}</p>
                            <p><strong>Filtro:</strong> {{ col.filter.toString() == '0' ? 'Não' : 'Sim' }}</p>
                            <p><strong>Saturação Mínima:</strong> {{ col.minSaturation }}</p>
                            <p><strong>Saturação Máxima:</strong> {{ col.maxSaturation }}</p>
                        </section>
                        <section v-if="col.type == 'collector' && col.colType == 'intelup'">
                            <p><strong>Base de Coleta:</strong> {{ col.collectorBase }}</p>
                            <p><strong>Nome da Tag:</strong> {{ col.tagname }}</p>
                            <p><strong>Tag Intelup:</strong> {{ col.inteluptagname }}</p>
                            <p><strong>Saturação Mínima:</strong> {{ col.minSaturation }}</p>
                            <p><strong>Saturação Máxima:</strong> {{ col.maxSaturation }}</p>
                        </section>
                    </section>
                </section>
            </section>
            <section class="infos-container" v-if="showRefs == true">
                <section class="info-header">
                    <h1>{{ this.$t('calculatedReference') }}</h1>
                    <b-icon-pencil-square @click="() => goToTab(2)"></b-icon-pencil-square>
                </section>

                <section class="info-content">
                    <span>Equação Criada</span>
                    <p><strong>Expressão: </strong>{{ this.equationPrev }}</p>
                    <span>Informações do Previsto</span>
                    <p><strong>Valor Previsto: </strong>{{ this.calculatedInfos.idealVal }}</p>
                    <p><strong>Tipo de Limite: </strong>{{ this.calculatedInfos.limitDesc }}</p>
                    <p v-if="this.calculatedInfos.limitCheck != 'down'"><strong>Limite Superior: </strong>{{
                        this.calculatedInfos.supLimit }}</p>
                    <p v-if="this.calculatedInfos.limitCheck != 'up'"><strong>Limite Inferior: </strong>{{
                        this.calculatedInfos.infLimit }}</p>
                    <p><strong>Range Crítico: </strong>{{ this.calculatedInfos.critic }}</p>
                </section>
            </section>
        </section>
        <img src="@/assets/salvar.png" :alt="$t('salvar')" :title="$t('salvar')" @click="saveCreationMode" />
    </section>
</template>
<script>
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';
import axios from 'axios';
import { urlMainAPI, defaultSuccess, showError } from '@/global';
import CustomLoading from '../commons/CustomLoading.vue';

export default {
    name: 'Abstract',
    props: {
        isCreating: Boolean,
        allowTab: Function,
        goToTab: Function,
        showRefs: Boolean

    },
    components: { CustomLoading },

    data() {
        return {
            generalInfos: {},
            collectedInfos: {},
            calculatedInfos: {},
            endingTask: false,
            loadingMsg: 'Enviando Dados',
            step: 'Configurações Gerais',
            isDetailSuccess: false,
            refsToShow: [],

            equationReal: '',
            equationPrev: '',
        }
    },

    methods: {
        async saveCreationMode() {
            this.endingTask = true;

            let cleanUnit = this.generalInfos.indicatorInfo.unit.replaceAll('(', '').replaceAll(')', '')

            let IndicatorDetails = {
                Indicatorid: 9999,
                IndicatorName: `${this.generalInfos.indicatorInfo.indicatorName} (${cleanUnit})`,
                CaclType: this.generalInfos.indicatorInfo.calcType.toLowerCase(),
            }

            let screens = this.generalInfos.screensToPosition.map(item => {
                return {
                    gridId: item.id,
                    gridName: item.screenName,
                    cols: item.cols,
                    indicatorsInScreens: item.children.map(card => {
                        return {
                            cardX: card.x,
                            cardY: card.y,
                            idIndicator: card.indicatorId.toString().includes('new') ? 9999 : card.indicatorId,
                        }
                    }),
                }
            })

            let indicatorsToSend = this.generalInfos.positionsOnTree.map(item => {
                return {
                    ...item,
                    indicatorId: 9999,
                }
            })


            let indicatorGeneralConfig = {
                indicatorsModified: indicatorsToSend,
                screensModified: screens
            }

            let indicatorInfosReal = {
                saveOnTree: {},
                saveOnCalculate: {},
                saveOnCollector: [],
            }

            let indicatorInfosPrev = {
                saveOnTree: {},
                saveOnCalculate: {},
                saveOnCollector: [],

            }


            if (this.showRefs == true) {

                let objToCalc = {
                    indicatorId: '',
                    indicatorName: this.generalInfos.indicatorInfo.indicatorName,
                    calcType: this.generalInfos.indicatorInfo.calcType.toLowerCase(),
                    valueEquation: '',
                    targetEquation: ''
                }

                let limitType = this.calculatedInfos.limitCheck == 'up' ? '>' : this.calculatedInfos.limitCheck == 'down' ? '<' : this.calculatedInfos.limitCheck == 'both' ? '=' : ''

                let ruleStr = `${limitType} ${this.calculatedInfos.critic} ${this.calculatedInfos.critic}`;

                MediatorIndicatorEditor.formatCollectedToReturn(this.collectedInfos.equation, indicatorInfosReal, objToCalc, this.collectedInfos.createdRefs)
                MediatorIndicatorEditor.formatCalculatedToReturn(this.calculatedInfos.equation, indicatorInfosPrev, objToCalc, this.calculatedInfos.createdRefs)

                indicatorInfosPrev.saveOnTree.limitRule = ruleStr
            }

            this.loadingMsg = 'Salvando Informações Gerais'

            await axios.post(`${urlMainAPI}/saveIndicatorDetails`, IndicatorDetails).then(async (res) => {
                if (res.status == 200) {
                    this.isDetailSuccess = true;
                    this.loadingMsg = 'Salvando Posicionamentos'

                    this.step = 'Posicionamento'
                    await axios.post(`${urlMainAPI}/saveGeneralConfigurationIndicatorsByEditor`, indicatorGeneralConfig)
                    this.loadingMsg = 'Salvando Equação Real'

                    if (this.showRefs == true) {
                        await axios.post(`${urlMainAPI}/saveEditorIndicatorRealTag`, indicatorInfosReal)
                        this.loadingMsg = 'Salvando Equação Prevista'
                        this.step = 'Referência Prevista'

                        await axios.post(`${urlMainAPI}/saveEditorIndicatorPrevTag`, indicatorInfosPrev)
                    }

                    this.loadingMsg = 'Finalizando'

                    defaultSuccess('Indicador criado com sucesso!');
                    window.location.reload();
                }
            }).catch(async (err) => {
                console.log(err)

                if (this.isDetailSuccess == true) {
                    this.loadingMsg = 'Falha ao salvar, desfazendo alterações.'
                    await axios.get(`${urlMainAPI}/roolbackEditorIndicator`)
                }

                showError(`Falha ao criar indicador na etapa ${this.step}`)
            })

            this.endingTask = false;
        }
    },

    created() {
        let generalStorage = MediatorIndicatorEditor.generalConfig;
        let collectedStorage = MediatorIndicatorEditor.collected;
        let calculatedStorage = MediatorIndicatorEditor.calculated;

        if (generalStorage != undefined && generalStorage != null) {
            this.generalInfos = generalStorage;
        }

        if (this.showRefs == true) {
            if (collectedStorage != undefined && collectedStorage != null) {
                this.collectedInfos = collectedStorage;

                let equationStr = '';

                this.collectedInfos.equation.forEach(item => {
                    if (item.type == "operation") {
                        equationStr += `${item.label} `;
                    } else if (item.type == 'reference' && item.structure && item.structure.type == 'fixed') {
                        equationStr += `${item.structure.value} `;
                    } else if (item.type == 'reference' && item.structure && item.structure.type == "collector") {
                        let foundRef = this.collectedInfos.createdRefs.filter(ref => ref.id == item.structure.id);

                        if (foundRef.length > 0) this.refsToShow.push(foundRef[0]);

                        let colName = `ind_real_${item.label}_online`
                        equationStr += `${colName} `;
                    } else if (item.type == 'calc' || item.type == "input") {
                        equationStr += `${item.label} `;
                    } else if (item.type == 'reference' && item.structure && item.structure.indicatorName) {
                        equationStr += `${item.label} `;
                    }
                })

                this.equationReal = equationStr;

            }

            if (calculatedStorage != undefined && calculatedStorage != null) {
                this.calculatedInfos = calculatedStorage;

                let limitType = this.calculatedInfos.limitCheck == 'up' ? 'Superior' : this.calculatedInfos.limitCheck == 'down' ? 'Inferior' : this.calculatedInfos.limitCheck == 'both' ? 'Ambos' : ''
                this.calculatedInfos.limitDesc = limitType;



                let equationStr = '';

                this.calculatedInfos.equation.forEach(item => {
                    if (item.type == "operation") {
                        equationStr += `${item.label} `;
                    } else if (item.type == 'reference' && item.structure && item.structure.type == 'fixed') {
                        equationStr += `${item.structure.value} `;
                    } else if (item.type == 'calc' || item.type == "input" || item.structure.type.toLowerCase() == 'gemeo' || item.structure.type == "plan") {
                        equationStr += `${item.label} `;
                    } else if (item.type == 'reference' && item.structure && item.structure.indicatorName) {
                        equationStr += `${item.label} `;
                    }
                })

                this.equationPrev = equationStr;
            }
        }
    }
}
</script>
<style scoped>
img {
    cursor: pointer;
    max-height: 35px;
    display: block;
    margin-left: auto;
    margin-right: 10px;
}

.abstract-container {
    padding: 0.8rem 0.3rem;
    display: flex;
    height: 100%;
    column-gap: 1rem;
}

.infos-container {
    width: 100%;
    height: 54vh;
    border: 1px solid #dbdbdb;
    border-radius: 0.3rem;
    padding: 0.8rem 0.5rem;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.info-header {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.8rem;
    margin-bottom: 1rem;
}

.info-header h1 {
    font-size: 1.2rem;
    margin: 0;
}

.info-header svg {
    color: #FF5F00;
    cursor: pointer;
    font-size: 1.5rem;
}

.info-content {
    overflow-y: auto;
    max-height: 44vh;
    padding-left: 0.5rem;
}

.info-content span {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: #9b9b9b;
    text-align: center;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
}

.info-content span::before {
    content: '';
    display: block;
    background-color: #0000001e;
    width: 100px;
    height: 1px;
}

.info-content span::after {
    content: '';
    display: block;
    background-color: #0000001e;
    width: 100px;
    height: 1px;
}

@media(min-height: 900px) {
    .infos-container {
        height: 65vh;
    }

    .info-content {
        max-height: 57vh;
    }
}
</style>